export function saveMenu(menu) {
  return function (dispatch) {
    dispatch({
      type: "SAVE_MENU",
      payload: {
        menu: menu
      }
    })
  }
}